import { render, staticRenderFns } from "./LoginFlowDone.vue?vue&type=template&id=0b288eb8"
import script from "./LoginFlowDone.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginFlowDone.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports